import React, { useState } from 'react';

import { FiFileText } from 'react-icons/fi';
import { IoIosArrowBack, IoIosArrowDown } from 'react-icons/io';

import { 
  Flex,
  Spacer,
  Text,
  Icon
} from '@chakra-ui/react';

import SubListItem from '../SubListItem';

const ListItem = ({ categoria, numArquivos, files }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Flex
        bgColor="#E3E3E3"
        h="40px"
        mt="10px"
        px="25px"
        py="10px"
        alignItems="center"
        cursor={'pointer'}
        onClick={() => { setOpen(!open); }}
      >
        <Text
          color="#1A203D"
          fontWeight="500"
          fontSize="14px"
          lineHeight="21.6px"
        >
          {categoria}
        </Text>
        <Spacer />
        <Text
          color="#1A203D"
          fontWeight="700"
          fontSize="16px"
          lineHeight="15px"
          mr="5px"
        >
          {numArquivos}
        </Text>
        <Icon 
          aria-label="Files" 
          color="rgba(0, 0, 0, 0.8)"
          as={FiFileText} 
          boxSize="20px"
          mr="15px"
        />
        {
          !open
          ?
          (
            <Icon 
              aria-label="Files" 
              color="rgba(0, 0, 0, 0.8)"
              as={IoIosArrowBack} 
              boxSize="20px"
            />
          )
          :
          (
            <Icon 
              aria-label="Files" 
              color="rgba(0, 0, 0, 0.8)"
              as={IoIosArrowDown} 
              boxSize="20px"
            />
          )
        }
        
      </Flex>
      {
        open && (
          files.map((file) => {
            return (
              <SubListItem 
                nome={file.nomeArquivo}
                data={file.dataAnexo}
                id={file.id}
                path={file.pathAnexo}
              />
            );
          })
        )
      }
    </>
  );
}

export default ListItem;